import React from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";

import IdentityDocCapture from "../IdentitiyDocCapture/index";
import DateField from "../../molecules/DateField";
import SelectCountry from "../../molecules/SelectCountry/index";
import LegalCheckbox from "../../molecules/LegalCheckbox/index";
import { Link } from "react-router-dom";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
    maxWidth: "350px"
  },
  checkboxError: {
    color: "red"
  },
  actionsContainer: {
    marginTop: theme.spacing(3)
  },
  menu: {
    width: 200
  },
  button: {
    marginRight: theme.spacing(1)
  }
});

const isDateSupported = () => {
  if (document) {
    var i = document.createElement("input");
    i.setAttribute("type", "date");
    return i.type !== "text";
  } else {
    return false;
  }
};

const now = new Date().getTime();
const minAge18 = new Date(now - 31557600 * 1000 * 18);
const maxAge120 = new Date(now - 31557600 * 1000 * 120);

class RegistrationForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      direction: null
    };

    // This binding is necessary to make `this` work in the callback
    this.handleClickNext = this.handleClickNext.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
  }
  handleClickNext(e, form) {
    e.preventDefault();
    this.setState({ direction: "next" });
    form.submitForm();
  }
  handleClickBack(e, form) {
    e.preventDefault();
    this.setState({ direction: "back" });
    form.submitForm();
  }
  renderAllErrorMsgs(errors) {
    const listErrors = errors => {
      let elist = [];
      Object.keys(errors).forEach((key, index) => {
        elist.push(
          <Typography key={key} style={{ color: "red" }} gutterBottom>
            {errors[key]}
          </Typography>
        );
      });
      return elist;
    };
    return (
      <Grid container spacing={10}>
        <Grid item style={{ marginTop: "2em" }}>
          {listErrors(errors)}
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;
    const { personal_information, confirmation, document } = this.props.data;
    return (
      <div>
        <Formik
          enableReinitialize={true}
          isInitialValid={false}
          initialValues={{
            full_first_name: personal_information.full_first_name,
            full_last_name: personal_information.full_last_name,
            street_address: personal_information.street_address,
            country: personal_information.country,
            zip: personal_information.zip,
            city: personal_information.city,
            nationality: personal_information.nationality,
            birthdate: personal_information.birthdate,
            email: personal_information.email,
            no_ico_country: confirmation.legal.lg01,
            document_type: document.document_type,
            document_id: document.document_id,
            frontside: document.document_images.frontside,
            backside: document.document_images.backside,
            selfi: document.document_images.selfi
          }}
          onSubmit={(values, actions) => {
            this.props.save({
              section: "personal_information",
              data: {
                full_first_name: values.full_first_name,
                full_last_name: values.full_last_name,
                street_address: values.street_address,
                country: values.country,
                zip: values.zip,
                city: values.city,
                nationality: values.nationality,
                birthdate: values.birthdate,
                email: values.email
              }
            });
            this.props.save({
              section: "confirmation",
              data: {
                legal: {
                  ...confirmation.legal,
                  lg01: values.no_ico_country
                }
              }
            });
            this.props.save({
              section: "document",
              data: {
                document_type: values.document_type,
                document_id: values.document_id,
                document_images: {
                  frontside: values.frontside,
                  backside: values.backside,
                  selfi: values.selfi
                }
              }
            });
            if (this.state.direction === "next") {
              this.props.next();
            } else if (this.state.direction === "back") {
              this.props.back();
            }
            actions.setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            full_first_name: Yup.string()
              .trim()
              .min(
                2,
                /*eslint-disable no-template-curly-in-string */
                "Must be at least ${min} characters."
              )
              .test(
                "is-xss",
                /*eslint-disable no-template-curly-in-string */
                "No valid characters.",
                value => !RegExp("[<>=:;%]").test(value)
              )
              .required("First name is required!"),
            full_last_name: Yup.string()
              .test(
                "is-xss",
                /*eslint-disable no-template-curly-in-string */
                "No valid characters.",
                value => !RegExp("[<>=:;%]").test(value)
              )
              .trim()
              .min(2, "Must be at least ${min} characters.")
              .required("Last name is required!"),
            street_address: Yup.string()
              .test(
                "is-xss",
                /*eslint-disable no-template-curly-in-string */
                "No valid characters.",
                value => !RegExp("[<>=:;%]").test(value)
              )
              .trim()
              .min(3, "Must be at least ${min} characters.")
              .required("Street address is required!"),
            country: Yup.mixed()
              // .required("Nationality is required!")
              .test("is-xss", "Country is required", function(value) {
                return value.name && value.alpha2Code;
              }),
            zip: Yup.string()
              .test(
                "is-xss",
                /*eslint-disable no-template-curly-in-string */
                "No valid characters.",
                value => !RegExp("[<>=:;%]").test(value)
              )
              .trim()
              .min(3, "Must be at least ${min} characters.")
              .required("ZIP is required!"),
            city: Yup.string()
              .test(
                "is-xss",
                /*eslint-disable no-template-curly-in-string */
                "No valid characters.",
                value => !RegExp("[<>=:;%]").test(value)
              )
              .trim()
              .min(3, "Must be at least ${min} characters.")
              .required("City is required!"),
            nationality: Yup.mixed()
              // .required("Nationality is required!")
              .test("is-xss", "Nationality is required", function(value) {
                return value.name && value.alpha2Code;
              }),
            birthdate: Yup.date()
              .max(
                minAge18,
                `Date of birth${
                  isDateSupported() ? "" : " (YYYY-MM-DD)"
                } should be equal or later than ${minAge18.getFullYear()}`
              )
              .min(
                maxAge120,
                `Date of birth${
                  isDateSupported() ? "" : " (YYYY-MM-DD)"
                } should be equal or earlier than ${maxAge120.getFullYear()}`
              )
              .required(
                `Date of birth${
                  isDateSupported() ? "" : " (YYYY-MM-DD)"
                } is required`
              ),
            email: Yup.string()
              .email("Invalid email address")
              .required("Email is required!"),
            no_ico_country: Yup.mixed().test(
              "is-checked",
              /*eslint-disable no-template-curly-in-string */
              "Not be a resident of a country wich does not allow to participate in an ICO needs to be agreed.",
              value => value.confirmation === true
            ),
            document_type: Yup.string().required("Document type is required!"),
            document_id: Yup.string()
              .test(
                "is-xss",
                /*eslint-disable no-template-curly-in-string */
                "No valid characters.",
                value => !RegExp("[<>=:;%]").test(value)
              )
              .trim()
              .min(3, "Must be at least ${min} characters.")
              .required("Document ID is required!"),
            frontside: Yup.mixed().required(
              "Front side of Document is required!"
            ),
            backside: Yup.mixed().when(
              "document_type",
              (document_type, schema) => {
                if (document_type === "ID Card") {
                  return schema.required("Back side of Document is required!");
                }
              }
            ),
            selfi: Yup.mixed().required("Close-up photo is required!")
          })}
          render={props => (
            <form
              onSubmit={props.handleSubmit}
              className={classes.container}
              name="RegistrationForm"
            >
              <Typography style={{ marginBottom: "1.5em" }} gutterBottom>
                Your personal data is required to maintain legal compliance
                regarding bank and exchange regulations.
              </Typography>
              <Grid container spacing={10}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    name="full_first_name"
                    label="Full First Name"
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.full_first_name}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.full_first_name !== "undefined"}
                    helperText={
                      props.errors.full_first_name &&
                      props.touched.full_first_name
                        ? props.errors.full_first_name
                        : "All names as written on your ID document - using the same alphabet and letters."
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    name="full_last_name"
                    label="Full Last Name"
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.full_last_name}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.full_last_name !== "undefined"}
                    helperText={
                      props.errors.full_last_name &&
                      props.touched.full_last_name
                        ? props.errors.full_last_name
                        : "All last names as written on your ID document - using the same alphabet and letters."
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    name="street_address"
                    label="Street"
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.street_address}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.street_address !== "undefined"}
                    helperText={
                      props.errors.street_address &&
                      props.touched.street_address
                        ? props.errors.street_address
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SelectCountry
                    name="country"
                    label="Country"
                    className={classes.textField}
                    //onChange={props.handleChange}
                    setFieldValue={props.setFieldValue}
                    value={props.values.country}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.country !== "undefined"}
                    helperText={
                      props.errors.country && props.touched.country
                        ? props.errors.country
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    name="zip"
                    label="Postal code"
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.zip}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.zip !== "undefined"}
                    helperText={
                      props.errors.zip && props.touched.zip
                        ? props.errors.zip
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    name="city"
                    label="City"
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.city}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.city !== "undefined"}
                    helperText={
                      props.errors.city && props.touched.city
                        ? props.errors.city
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SelectCountry
                    name="nationality"
                    label="Nationality"
                    className={classes.textField}
                    //onChange={props.handleChange}
                    setFieldValue={props.setFieldValue}
                    value={props.values.nationality}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.nationality !== "undefined"}
                    helperText={
                      props.errors.nationality && props.touched.nationality
                        ? props.errors.nationality
                        : "As written on your passport / ID Card"
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DateField
                    type="date"
                    name="birthdate"
                    label={isDateSupported() ? " " : "Date of Birth"}
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.birthdate}
                    min={minAge18}
                    max={maxAge120}
                    onBlur={props.handleBlur}
                    error={typeof props.errors.birthdate !== "undefined"}
                    helperText={
                      props.errors.birthdate && props.touched.birthdate
                        ? props.errors.birthdate
                        : "Date of Birth" +
                          (isDateSupported() ? "" : " (YYYY-MM-DD)")
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="email"
                    name="email"
                    label="Email"
                    className={classes.textField}
                    onChange={props.handleChange}
                    value={props.values.email}
                    required
                    onBlur={props.handleBlur}
                    error={typeof props.errors.email !== "undefined"}
                    helperText={
                      props.errors.email && props.touched.email
                        ? props.errors.email
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <LegalCheckbox
                    name="no_ico_country"
                    context={["ico", "no ico country"]}
                    defaultState={false}
                    setFieldValue={props.setFieldValue}
                    value={props.values.no_ico_country}
                    error={typeof props.errors.no_ico_country !== "undefined"}
                  >
                    I am NOT a resident or a citizen of USA, China, Republic of
                    Korea, Canada, New Zealand, Singapore or Cayman Islands.
                  </LegalCheckbox>
                </Grid>
              </Grid>
              <IdentityDocCapture
                values={props.values}
                errors={props.errors}
                touched={props.touched}
                handleBlur={props.handleBlur}
                handleChange={props.handleChange}
                setFieldValue={props.setFieldValue}
              />
              {this.renderAllErrorMsgs(props.errors)}

              <div className={classes.actionsContainer}>
                {this.props.edit && (
                  <Button
                    variant="outlined"
                    component={Link}
                    to="/dashboard"
                    className={classes.button}
                    type="button"
                  >
                    Cancel
                  </Button>
                )}
                {!this.props.edit && (
                  <Button
                    onClick={e => {
                      this.handleClickBack(e, props);
                    }}
                    disabled={this.props.step === 0}
                    className={classes.button}
                    type="button"
                  >
                    Back
                  </Button>
                )}
                <Button
                  //type="submit"
                  name="next"
                  color="primary"
                  onClick={e => {
                    this.handleClickNext(e, props);
                  }}
                  variant="outlined"
                  className={classes.button}
                >
                  {this.props.step === this.props.maxsteps - 1
                    ? "Finish"
                    : this.props.edit
                    ? "Save"
                    : "Next"}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}

RegistrationForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RegistrationForm);
